import type { ProductType, Prompt } from "@1js/pl-card-components";
import { type HandoffCallbackResult } from "../hooks/handoff.types";
import {
  handoffAsync,
  type HandoffResponse,
  type IHandoffErrorResponseMessage,
} from "../services/augloop-client.web";

const isError = (
  response: HandoffResponse
): response is IHandoffErrorResponseMessage => {
  return (<IHandoffErrorResponseMessage>response).error !== undefined;
};

/**
 * Handles handoff to Augloop Handoff service, to try prompts in Word, Excel, PowerPoint, Outlook, or OneNote.
 * @param _host - The host of SupportService
 * @param locale - The locale of the user
 * @param promptText - The prompt command text to handoff
 * @param destinationApp - The destination product or service to handoff the prompt to
 * @param fileId - The file id of the file to handoff to
 * @returns handoffUrl to direct customer to in browser, or error if handoff failed
 */
export const handoffToAugloop = async (
  host: string,
  locale: string,
  prompt: Prompt,
  product: ProductType | string,
  fileId?: string
): Promise<HandoffCallbackResult> => {
  const context = fileId; // ToDo (annbal): How to pass file?

  const response: HandoffResponse = await handoffAsync(
    host,
    locale,
    product,
    prompt.CommandText,
    undefined,
    undefined,
    context
  );

  const handoffUrl = isError(response)
    ? ""
    : response.responses[0]?.generatedLinks[0]?.platformHandoffUrl;
  const reference = handoffUrl && window.open(handoffUrl);

  if (isError(response)) {
    throw new Error("AugloopError");
  } else if (
    response.responses.length == 0 ||
    response.responses[0].generatedLinks.length == 0
  ) {
    throw new Error("NoResponse");
  } else if (!reference) {
    throw new Error("PopupBlocked");
  }

  return {
    handoffUrl,
  };
};
